export function createSerie() {
  return {
    Clave: '',
    EmpresaId: 0,
    ObjetoId: 0,
    Nombre: '',
    SiguienteFolio: 0,
    ClaveErp: '',
    EsActivo: true,
    TipoDocumento: '',
    Serie: '',
    FolioInicial: 0,
    FolioFinal: 0,
    Estatus: ''
  };
}
